var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.026 14.69c-.58.004-.903-.534-.667-1.02.34-.696.688-1.388 1.032-2.08.275-.554.55-1.109.825-1.667.065-.134.146-.245.25-.353 1.865-1.865 3.73-3.726 5.591-5.596.082-.082.125-.107.22-.009.894.916 1.792 1.823 2.69 2.73.082.086.086.124 0 .21C9.093 8.775 7.22 10.65 5.35 12.52a1.14 1.14 0 0 1-.31.223c-1.23.61-2.458 1.221-3.692 1.831-.116.065-.236.12-.322.116ZM12.064 5.792 9.115 2.844c.473-.456.937-.924 1.427-1.363.602-.546 1.316-.692 2.076-.425.77.27 1.23.834 1.363 1.642.103.632-.06 1.203-.486 1.667-.455.499-.954.959-1.431 1.427ZM10.25 13.31h2.982c.108 0 .215 0 .318.034.318.104.508.4.473.735a.674.674 0 0 1-.61.606c-.06.005-.116.009-.176.009h-5.98c-.184 0-.36-.022-.515-.138a.708.708 0 0 1-.262-.73.68.68 0 0 1 .58-.507c.103-.013.202-.013.305-.013.959.004 1.922.004 2.884.004Z",
    fill: "#010101"
  })));
};

export default SvgPencil;